import { render, staticRenderFns } from "./OTPPicker.vue?vue&type=template&id=3fbcb7a8&scoped=true"
import script from "./OTPPicker.vue?vue&type=script&lang=js"
export * from "./OTPPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbcb7a8",
  null
  
)

export default component.exports